export default __webpack_public_path__ + "static/media/offline16.cb67b9eb.png";